/* eslint-disable */
import globalStyles from '../../../global.styles';
import deliveryServiceStyles from '../../../Services/Delivery/Delivery.service.styles';
import ordersServiceStyles from '../../../Services/Order/Order.service.styles';
import i18nIsLtr from '../../I18n/IsLtr/I18nIsLtr.support';
import i18nIsRtl from '../../I18n/IsRtl/I18nIsRtl.support';
import isFunction from '../../Is/Function/IsFunction';
import themeIsDark from '../IsDark/ThemeIsDark.support';
import themeIsLight from '../IsLight/ThemeIsLight.support';
import boralcolorspalette from '../Colors/Colors';

/**
 * Inject support functions into the `style`
 * @param {Function | Object} style If the `style` is a Function, we inject the _support_ Function's otherwise we just return it.
 * @param {MuiTheme} theme The current `theme`
 * @returns {Object} The `style` object
 */
const injectSupport = (style, theme) => {
  if (!isFunction(style)) {
    return style;
  }
  return style({
    isDark: () => themeIsDark(theme.palette.type),
    isLight: () => themeIsLight(theme.palette.type),
    isLtr: () => i18nIsLtr(theme.direction),
    isRtl: () => i18nIsRtl(theme.direction),
    theme,
  });
};

/**
 * Create a styles object to pass to `withStyles`. This method allows setting up custom `DI` and combining multiple styles, all of which `withStyles` currently
 * does not support. If a Function is provided, it has _support_ methods injected into it as well as the current theme, otherwise it just returns the defined
 * `styles` object. Also, this blends the provided styles with `globalStyles`.
 * @param {Array<Function | Object>} styles The styles to process
 * @returns {Object} The newly created styles
 */
const themeCreateInjectableStyles = (...styles) => (theme) => {
  return [globalStyles, deliveryServiceStyles, ordersServiceStyles, ...styles].reduce(
    (prevStyles, style) => ({
      ...prevStyles,
      ...injectSupport(style, { ...theme, boralcolorspalette }),
    }),
    {},
  );
};

export default themeCreateInjectableStyles;
